import { html, utl_fadeIn, utl_renderObjects } from "../base/_utils";
import { staff } from "../data/_staff";
import { staffCard } from "../components/templates/_staff-card";

window.addEventListener("load", () => {
    utl_renderObjects({
        data: staff,
        template: (member) => html`<div class="col-md-4 col-lg-3 mb-4 pb-1 px-3">${staffCard(member, "../")}</div>`,
        target: "#staff-container",
    });

    utl_fadeIn();
});
